import ActionTypes from '../constants/actionTypes'
import store from '../store'

export function changeDate(date) {
  return store.dispatch({
    type: ActionTypes.CHANGE_DATE,
    payload: date,
  })
}

export function toggleModal(open) {
  return store.dispatch({
    type: ActionTypes.TOGGLE_MODAL,
    payload: open,
  })
}

export function addReminder({ reminder, shouldDeleteDate }) {
  return store.dispatch({
    type: ActionTypes.ADD_REMINDER,
    payload: { reminder, shouldDeleteDate },
  })
}

export function editingReminder(reminder) {
  return store.dispatch({
    type: ActionTypes.EDITING_REMINDER,
    payload: reminder,
  })
}

export function deleteReminder(reminder) {
  return store.dispatch({
    type: ActionTypes.DELETE_REMINDER,
    payload: reminder,
  })
}
